import { render } from "./TeamsBoardComponent.vue?vue&type=template&id=35842c9c"
import script from "./TeamsBoardComponent.vue?vue&type=script&lang=js"
export * from "./TeamsBoardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__